
import Grid1 from "../../../assets/duotone/Grid1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Grid1Icon({ className, dataTestid = "Grid1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Grid1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
